import React, { createContext, useContext, useState } from 'react';

// Admin's active workspace — controls what the Workspace page shows.
// Retail = Chennai 22K gold pipeline. Trade = XAU/USD spot.
// Stored in localStorage so the choice persists across reloads.
const WorkspaceContext = createContext({ workspace: 'retail', setWorkspace: () => {} });

const STORAGE_KEY = 'genie.workspace';
const DEFAULT_WORKSPACE = 'retail';
const VALID = ['retail', 'trade', 'remit', 'depart'];

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspaceState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return VALID.includes(stored) ? stored : DEFAULT_WORKSPACE;
    } catch { return DEFAULT_WORKSPACE; }
  });

  const setWorkspace = (next) => {
    if (!VALID.includes(next)) return;
    setWorkspaceState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch {}
  };

  return (
    <WorkspaceContext.Provider value={{ workspace, setWorkspace }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  return useContext(WorkspaceContext);
}

export const WORKSPACES = [
  { id: 'retail', label: 'Retail', color: '#3b82f6', sub: 'Chennai 22K · gold' },
  { id: 'remit',  label: 'Remit',  color: '#22c55e', sub: 'USD/INR · send or wait' },
  { id: 'depart', label: 'Depart', color: '#f97316', sub: 'Gulf → India · book or wait' },
  { id: 'trade',  label: 'Trade',  color: '#a855f7', sub: 'XAU/USD spot' },
];
